@ts-nocheck
<template>

  <!--    <div class="alert alert-primary alert-dismissible" role="alert">
        Добавлена новая вакансия
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>-->

  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-0">
      <div class="p-4">
        <div class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
          <h3 class="mb-0">Вакансия</h3>
        </div>

        <form @submit.prevent="submit">
          <!-- First Row -->
          <div class="row g-3">
            <div class="col-lg-2">
              <input type="text" v-model="temp.title" class="form-control" placeholder="Название">
            </div>
            <div class="col-lg-2">
              <input type="text" v-model="temp.number" class="form-control" placeholder="Номер">
            </div>
            <div class="col-lg-2">
              <select v-model="temp.managerId" @change="updateMainCoordinators" class="form-control">
                <option v-for="manager in managers" :key="manager.id" :value="manager.id">
                  {{ manager.name }}
                </option>
              </select>
            </div>
            <div class="col-lg-2">
              <select v-model="temp.mainCoordinatorId" @change="updateCoordinators" class="form-control">
                <option
                    v-for="main_coordinator in main_coordinators.filter(mc => mc && mc.owner_id === temp.managerId)"
                    :key="main_coordinator.id"
                    :value="main_coordinator.id">
                  {{ main_coordinator.name }}
                </option>
              </select>
            </div>
            <div class="col-lg-2">
              <select v-model="temp.coordinatorId" @change="setCoordinatorPhone" class="form-control">
                <option
                    v-for="coordinator in coordinators.filter(c =>  c &&
                    (c.owner_id === temp.mainCoordinatorId || (dialogStatus === 'update' && !temp.mainCoordinatorId && !temp.managerId)))"
                    :key="coordinator.id"
                    :value="coordinator.id">
                  {{ coordinator.name }}
                </option>
              </select>
            </div>
            <div class="col-lg-2">
              <input type="text" v-model="temp.coordinatorPhone" class="form-control" placeholder="Тел. коорд.">
            </div>
          </div>

          <!-- Candidates Section -->
          <div><br/>
            <h3 class="mb-1">Кандидат</h3>
            <div v-for="(candidate, index) in temp.candidates" :key="index" class="mb-3">
              <div class="row g-3">
                <div class="col-lg-2">
                  <input type="text" v-model="candidate.position" class="form-control" placeholder="Должность">
                </div>
                <div class="col-lg-1">
                  <input type="text" v-model="candidate.rate" class="form-control" placeholder="Ставка">
                </div>
                <div class="col-lg-1">
                  <select v-model="candidate.rateFrequency" class="form-control">
                    <option value="1">в час</option>
                    <option value="2">в день</option>
                    <option value="3">в месяц</option>
                  </select>
                </div>
                <div class="col-lg-2">
                  <input type="number" v-model="candidate.quantity1" class="form-control" placeholder="Мужчин">
                </div>
                <div class="col-lg-2">
                  <input type="number" v-model="candidate.quantity2" class="form-control" placeholder="Женщин">
                </div>
                <div class="col-lg-2">
                  <input type="number" v-model="candidate.quantity3" class="form-control" placeholder="Пар">
                </div>
                <div class="col-lg-1">
                  <input type="text" v-model="candidate.age" class="form-control" placeholder="Возраст">
                </div>
                <div class="col-lg-1">
                  <el-select
                      v-model="candidate.nation"
                      multiple
                      placeholder=""
                  >
                    <el-option
                        v-for="nation in nations"
                        :key="nation"
                        :label="nation"
                        :value="nation"
                    />
                  </el-select>
                </div>
              </div>


              <!--                    <div class="row g-3">
                                    <div class="col-md-12">
                                      <div class="mb-3">
                                        <label for="title" class="form-label">Адрес жилья</label>
                                        <input type="text" id="title" v-model="temp.living" class="form-control" placeholder="Адрес жилья">
                                      </div>

                                      <div class="mb-3">
                                        <label for="livingPlaces1" class="form-label">Количество мест для мужчин</label>
                                        <input type="text" id="livingPlaces1" v-model="candidate.livingPlaces1" class="form-control" placeholder="Количество мест для мужчин">
                                      </div>
                                      <div class="mb-3">
                                        <label for="livingPlaces2" class="form-label">Количество мест для женщин</label>
                                        <input type="text" id="livingPlaces2" v-model="candidate.livingPlaces2" class="form-control" placeholder="Количество мест для женщин">
                                      </div>
                                      <div class="mb-3">
                                        <label for="livingPlaces3" class="form-label">Количество мест для пар</label>
                                        <input type="text" id="livingPlaces3" v-model="candidate.livingPlaces3" class="form-control" placeholder="Количество мест для пар">
                                      </div>

                                      <div class="mb-3">
                                        <label for="description" class="form-label">Описание</label>
                                        <textarea
                                          id="description"
                                          v-model="candidate.description"
                                          class="form-control"
                                          rows="3"
                                          :placeholder="`Описание ${candidate.position}`"></textarea>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="row g-3">
                                    <div class="col-md-6">
                                      <input type="text" id="city" v-model="candidate.city" class="form-control" placeholder="Город">
                                    </div>

                                    <div class="col-md-6">
                                      <div class="mb-3">
                                        <input type="text" id="address" v-model="candidate.address" class="form-control" placeholder="Адрес">
                                      </div>
                                    </div>

                                    <div class="col-md-6">
                                      <div class="mb-3">
                                        <select id="workShift" v-model="candidate.workShift" class="form-select">
                                          <option value="1">Одна смена</option>
                                          <option value="2">Две смены</option>
                                          <option value="3">Три смены</option>
                                        </select>
                                      </div>

                                      <div class="mb-3" v-if="candidate.workShift">
                                        <input
                                          type="text"
                                          v-model="candidate.schedule1"
                                          class="form-control mb-2"
                                          :disabled="!candidate.workShift"
                                          placeholder="График смена 1">
                                        <input
                                          type="text"
                                          v-model="candidate.schedule2"
                                          class="form-control mb-2"
                                          :disabled="!candidate.workShift || candidate.workShift === 1"
                                          placeholder="График смена 2"
                                          v-if="candidate.workShift === 2 || candidate.workShift === 3">
                                        <input
                                          type="text"
                                          v-model="candidate.schedule3"
                                          class="form-control"
                                          :disabled="candidate.workShift !== 3"
                                          placeholder="График смена 3"
                                          v-if="candidate.workShift === 3">
                                      </div>
                                    </div>

                                    <div class="col-md-6">
                                      <div class="mb-3">
                                        <select id="workShiftType" v-model="candidate.workShiftType" class="form-select">
                                          <option value="1">Дневные</option>
                                          <option value="2">Ночные</option>
                                          <option value="3">Смешанные</option>
                                        </select>
                                      </div>
                                    </div>

                                    <div class="col-md-6">
                                      <div class="mb-3">
                                        <select id="livingExists" v-model="candidate.livingExists" class="form-select">
                                          <option value="0">Жилья нет</option>
                                          <option value="1">Жильё есть</option>
                                        </select>
                                      </div>
                                      <div v-if="candidate.livingExists === 1">
                                        <div class="mb-3">
                                          <label for="livingType" class="form-label">Тип жилья</label>
                                          <select id="livingType" v-model="candidate.livingType" class="form-select">
                                            <option value="1">Пара отдельно</option>
                                            <option value="2">По две пары</option>
                                            <option value="3">Нет мест</option>
                                          </select>
                                        </div>
                                        <div class="mb-3">
                                          <label for="livingPrice" class="form-label">Цена жилья</label>
                                          <input type="text" id="livingPrice" v-model="candidate.livingPrice" class="form-control" placeholder="Цена жилья">
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col-md-6">
                                      <div class="mb-3">
                                        <select id="isArrival" v-model="candidate.isArrival" class="form-select">
                                          <option value="0">Доезда нет</option>
                                          <option value="1">Доезд есть</option>
                                        </select>
                                      </div>
                                      <div v-if="candidate.isArrival === 1">
                                        <div class="mb-3">
                                          <label for="arrivalAddress" class="form-label">Адрес</label>
                                          <input type="text" id="arrivalAddress" v-model="candidate.arrivalAddress" class="form-control" placeholder="Адрес">
                                        </div>
                                        <div class="mb-3">
                                          <label for="arrivalPrice" class="form-label">Цена</label>
                                          <input type="text" id="arrivalPrice" v-model="candidate.arrivalPrice" class="form-control" placeholder="Цена">
                                        </div>
                                      </div>
                                    </div>
                                  </div>-->


            </div>

            <button class="btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg"
                    @click="addCandidateRow">
                                    <span class="py-sm-1 d-block">
                                        <i class="ri-add-line d-none d-sm-inline-block"></i>
                                        <span>
                                        </span>
                                    </span>
            </button>
            <br/> <br/>

          </div>


          <div v-for="(candidate, index) in temp.candidates" :key="index"
               class="candidate-row border rounded p-3 mb-4">
            <h3>
              Описание
              <span v-if="candidate.position">
        ({{ candidate.position }})
        <span v-if="candidate.isActive === 0">(неактивна)</span>

        <button
            v-if="candidate.isActive === 1"
            class="btn btn-warning btn-sm mx-1"
            title="Деактивировать должность"
            @click="setCandidateStatus(candidate, 0)"
        >
          Деактивировать
        </button>

        <button
            v-if="candidate.isActive === 0"
            class="btn btn-success btn-sm mx-1"
            title="Активировать должность"
            @click="setCandidateStatus(candidate, 1)"
        >
          Активировать
        </button>

        <button
            class="btn btn-danger btn-sm mx-1"
            title="Удалить должность"
            @click="deleteCandidateRow(candidate)"
        >
          Удалить должность
        </button>
      </span>
            </h3>

            <!-- First Row -->
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" class="form-control" v-model="candidate.city" placeholder="Город"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" class="form-control" v-model="candidate.address" placeholder="Адрес"/>
                </div>
              </div>
            </div>

            <!-- Second Row -->
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="form-group">
                  <select class="form-control" v-model="candidate.workShift">
                    <option :value="1">Одна смена</option>
                    <option :value="2">Две смены</option>
                    <option :value="3">Три смены</option>
                  </select>
                </div>

                <div class="form-group" v-if="candidate.workShift">
                  <br/>
                  <input
                      type="text"
                      class="form-control"
                      v-model="candidate.schedule1"
                      :disabled="!candidate.workShift"
                      placeholder="график смена 1"
                  />
                </div>

                <div class="form-group"
                     v-if="candidate.workShift && (candidate.workShift === 2 || candidate.workShift === 3)">
                  <br/>
                  <input
                      type="text"
                      class="form-control"
                      v-model="candidate.schedule2"
                      :disabled="!candidate.workShift || candidate.workShift === 1"
                      placeholder="график смена 2"
                  />
                </div>

                <div class="form-group" v-if="candidate.workShift && candidate.workShift === 3">
                  <br/>
                  <input
                      type="text"
                      class="form-control"
                      v-model="candidate.schedule3"
                      :disabled="!candidate.workShift || candidate.workShift === 1 || candidate.workShift === 2"
                      placeholder="график смена 3"
                  />
                </div>

              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <select class="form-control" v-model="candidate.workShiftType">
                    <option :value="1">Дневные</option>
                    <option :value="2">Ночные</option>
                    <option :value="3">Смешанные</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Third Row -->
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="form-group">
                  <select class="form-control" v-model="candidate.livingExists">
                    <option :value="0">Жилья нет</option>
                    <option :value="1">Жильё есть</option>
                  </select>
                </div>
                <div class="form-group" v-if="candidate.livingExists === 1">
                  <br/>
                  <select class="form-control" v-model="candidate.livingType">
                    <option :value="1">Пара отдельно</option>
                    <option :value="2">По две пары</option>
                    <option :value="3">Нет мест</option>
                  </select>
                </div>
                <div class="form-group" v-if="candidate.livingExists === 1">
                  <br/>
                  <input type="text" class="form-control" v-model="candidate.livingPrice"
                         placeholder="цена жилья"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <select class="form-control" v-model="candidate.isArrival">
                    <option :value="0">Доезда нет</option>
                    <option :value="1">Доезд есть</option>
                  </select>
                </div>
                <div class="form-group" v-if="candidate.isArrival === 1">
                  <br/>
                  <input type="text" class="form-control" v-model="candidate.arrivalAddress"
                         placeholder="адрес"/>
                </div>
                <div class="form-group" v-if="candidate.isArrival === 1">
                  <br/>
                  <input type="text" class="form-control" v-model="candidate.arrivalPrice" placeholder="цена"/>
                </div>
              </div>
            </div>

            <!-- Fourth Row -->
            <div class="row mb-3">
              <div class="col-md-4">
                <div class="form-group">
                  <input type="text" class="form-control" v-model="candidate.livingPlaces1"
                         placeholder="Мужчин"/>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input type="text" class="form-control" v-model="candidate.livingPlaces2"
                         placeholder="Женщин"/>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input type="text" class="form-control" v-model="candidate.livingPlaces3" placeholder="Пар"/>
                </div>
              </div>
            </div>

            <!-- Description -->
            <div class="form-group">
                      <textarea
                          class="form-control description"
                          v-model="candidate.description"
                          rows="10"
                          cols="10"
                          :placeholder="`Описание ${candidate.position}`">
                      </textarea>
            </div>
          </div>


          <!--                <div class="mb-4 pb-2">-->
          <!--                  <h4 class="fs-15 fw-semibold border-bottom pb-2 mb-3">Активная</h4>-->
          <!--                  <div class="settings-btn rtl-btn">-->
          <!--                    <label id="switch" class="switch">-->
          <!--                      <input type="checkbox" onchange="toggleTheme()" id="slider">-->
          <!--                      <span class="sliders round"></span>-->
          <!--                    </label>-->
          <!--                  </div>-->
          <!--                </div>-->

          <div class="form-group">
                      <textarea
                          class="form-control description"
                          v-model="temp.comment"
                          rows="10"
                          cols="10"
                          placeholder="Комментарий"
                      ></textarea>
          </div>


          <div class="col-lg-12 toggle-row">
            <!-- Toggle 1 -->
            <div class="toggle-container">
              <label class="toggle-label">Активная</label>
              <label class="toggle-switch">
                <input type="checkbox" class="toggle-input" v-model="temp.isActive"/>
                <span class="toggle-slider"></span>
              </label>
            </div>

            <!-- Toggle 2 -->
            <div class="toggle-container">
              <label class="toggle-label">Приоритет</label>
              <label class="toggle-switch">
                <input type="checkbox" class="toggle-input" v-model="temp.isPriority"/>
                <span class="toggle-slider"></span>
              </label>
            </div>

            <!-- Toggle 3 -->
            <div class="toggle-container">
              <label class="toggle-label">Для посредников</label>
              <label class="toggle-switch">
                <input type="checkbox" class="toggle-input" v-model="temp.isMediator"/>
                <span class=" toggle-slider"></span>
              </label>
            </div>
          </div>

          <!-- Buttons -->
          <div class="mt-4">
            <a href="/vacancies/status1" class="btn btn-danger me-3">Отменить</a>
            <button class="btn btn-primary" @click="isEditPage ? updateData() : createData()">
              <i class="bi bi-plus"></i> Сохранить
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck
import {fetchList, createVacancy, updateVacancy, deleteVacancy} from '@/api/vacancy';
import {defineComponent, ref, reactive} from "vue";
import Pagination from "@/components/Common/Pagination.vue";
import axios from 'axios';
import echo from '../../../../echo';
import {ElSelect, ElOption} from 'element-plus';
import 'element-plus/dist/index.css';

export default defineComponent({
  name: "ProjectsList",
  components: {
    Pagination,
    ElSelect,
    ElOption
  },
  data() {
    return {
      nations: [
        'Армения',
        'Беларусь',
        'Грузия',
        'Молдова',
        'Украина'
      ],
      isEditPage: false,
      vacancyId: null,
      isOpen: false,
      isOpen2: false,
      isMobile: false,
      userRole: '',
      user: '',
      tableKey: 0,
      managers: [],
      main_coordinators: [],
      coordinators: [],
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        // page: 1,
        // limit: 20,
        search: '',
        sort: '',
      },
      sortOptions: [{label: 'ID Ascending', key: '+id'}, {label: 'ID Descending', key: '-id'}],
      statusOptions: ['published', 'draft', 'deleted'],
      showReviewer: false,
      candidatesToDelete: [],
      candidatesToHide: [],
      temp: {
        //managerId: null,
        //mainCoordinatorId: null,
        //coordinatorId: null,
        candidatesToDelete: [],
        candidatesToHide: [],
        title: '',
        isActive: true,
        gender: [],
        images: [],
        coordinatorPhone: '',
        candidates: [
          {
            isActive: '',
            position: '',
            rate: '',
            rateFrequency: 1,
            quantity1: '',
            quantity2: '',
            quantity3: '',
            age: '',
            nation: [],
            city: '',
            address: '',
            workShift: '',
            workShiftType: '',
            schedule1: '',
            schedule2: '',
            schedule3: '',
            livingExists: '',
            livingType: '',
            livingPrice: '',
            livingPlaces1: '',
            livingPlaces2: '',
            livingPlaces3: '',
            isArrival: '',
            arrivalAddress: '',
            arrivalPrice: '',
          }
        ]
      },
      dialogFormVisible: false,
      dialogFieldsVisible: false,
      dialogStatus: '',
      dialogPvVisible: false,
      fields: [
        {label: 'Вакансия', name: 'title', showAsMain: true},
        {label: 'Название', name: 'title', showAsDetails: true},
        {label: 'Город', name: 'city', showAsMain: true},
        {label: 'Должность', name: 'position', showAsMain: true, showAsDetails: true},
        {label: 'Ставка', name: 'rate', showAsMain: false, showAsDetails: true},
        {label: 'Жилье', name: 'livingExists', showAsMain: true},
        {label: 'Гражданство', name: 'nation', showAsMain: true},
        {label: 'Доезд', name: 'isArrival', showAsMain: true},
        {label: 'Требуются', name: 'gender', showAsMain: false},
        {label: 'Смены', name: 'schedule1'},
        {label: 'Возраст', name: 'age', showAsDetails: true},
        {label: 'График', name: 'schedule1', showAsDetails: true},
        {label: 'Смены', name: 'schedule2'},
        {label: 'Смены', name: 'schedule3'},
        {label: 'Пары', name: 'pairs', showAsMain: false},
        {label: 'Координатор', name: 'coordinatorId', showAsDetails: true},
        {label: 'Тел. коорд.', name: 'coordinatorPhone', showAsDetails: true},
        {label: 'Количество людей', name: 'quantity1'},
        {label: 'Цена жилья', name: 'livingPrice'},
        {label: 'Адрес жилья', name: 'living', showAsDetails: true},
        {label: 'Адрес', name: 'address', showAsDetails: true},
        {label: 'Смена', name: 'workShift'},
        {label: 'Тип смены', name: 'workShiftType'},
        {label: 'Описание', name: 'description'},
        {label: 'Комментарий', name: 'comment'},
        {label: 'Активная', name: 'isActive'},
        {label: 'Приоритет', name: 'isPriority'},
        {label: 'Для посредников', name: 'isMediator'},
        {label: 'Адрес доезда', name: 'arrivalAddress'},
        {label: 'Цена доезда', name: 'arrivalPrice'},
      ],
      rules: this.setRules(),
      downloadLoading: false,
    };
  },
  methods: {
    addDelay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    menuItemToggle() {
      this.isOpen = !this.isOpen; // Toggles the `open` class
    },
    menuItemToggle2() {
      this.isOpen2 = !this.isOpen2; // Toggles the `open` class
    },
    checkScreenSize() {
      this.isMobile = window.matchMedia("(max-width: 767px)").matches;
      console.log(this.isMobile ? 'This is a mobile screen size.' : 'This is not a mobile screen size.');
    },
    getRowClass({row}) {
      //return row.isPriority ? 'priority-row' : 'priority-row1';
      return 'priority-row1';
    },
    updateMainCoordinators() {
      console.log('update main coords');
      // Filter main_coordinators based on selected manager
      // const manager = this.managers.find(
      //   (m) => m.id === this.temp.managerId
      // );
      // this.main_coordinators = this.main_coordinators.filter(
      //   (c) => c.owner_id === (manager ? manager.id : null)
      // );

      // Reset dependent fields
      this.temp.mainCoordinatorId = null;
      this.temp.coordinatorId = null;
      //this.coordinators = [];
    },
    updateCoordinators() {
      // Filter coordinators based on selected main_coordinator
      // const mainCoordinator = this.main_coordinators.find(
      //   (mc) => mc.id === this.temp.mainCoordinatorId
      // );
      // this.coordinators = this.coordinators.filter(
      //   (c) => c.owner_id === (mainCoordinator ? mainCoordinator.id : null)
      // );

      // Reset dependent field
      this.temp.coordinatorId = null;
    },
    setCoordinatorPhone(e) {
      // Get the selected value from the event target
      const selectedCoordinatorId = e.target.value;
      console.log('Selected Coordinator ID:', selectedCoordinatorId);

      // Find the coordinator object in the coordinators array
      const coordFind = this.coordinators.find(u => u.id === Number(selectedCoordinatorId));
      console.log('Found Coordinator:', coordFind);

      // Check if coordFind is defined before accessing its properties
      if (coordFind) {
        this.temp.coordinatorPhone = coordFind.phone; // Set the phone number
      } else {
        this.temp.coordinatorPhone = ''; // Set to empty string or handle the case where no coordinator is found
      }
    },
    addCandidate() {

    },
    addCandidateRow() {
      this.temp.candidates.push(
          {
            isActive: '',
            position: '',
            rate: '',
            rateFrequency: 1,
            quantity1: '',
            quantity2: '',
            quantity3: '',
            age: '',
            nation: [],
            city: '',
            address: '',
            workShift: '',
            workShiftType: '',
            schedule1: '',
            schedule2: '',
            schedule3: '',
            livingExists: '',
            livingType: '',
            livingPrice: '',
            livingPlaces1: '',
            livingPlaces2: '',
            livingPlaces3: '',
            isArrival: '',
            arrivalAddress: '',
            arrivalPrice: '',
          }
      );
    },
    setCandidateStatus(candidate, status) {
      const index = this.temp.candidates.indexOf(candidate);
      if (index !== -1) {
        this.temp.candidates[index].isActive = status;
      } else {
        console.error("Candidate not found");
      }
    },
    deleteCandidateRow(candidate) {
      const index = this.temp.candidates.indexOf(candidate);
      if (index !== -1) {
        // If candidate has an ID, add it to the candidatesToDelete array
        if (candidate.id) {
          this.candidatesToDelete.push(candidate.id);
        }
        this.temp.candidates.splice(index, 1);  // Remove candidate from the list
      }
    },
    parseStatusFromUrl() {
      /*    const path = this.$route.path;
          const regex = /status(\d+)/;
          const match = path.match(regex);

          if (path.includes('create')) {
            this.handleCreate();
            return;
          }

          if (path.includes('edit')) {
            const id = parseInt(path.split('/').pop());
            const item = this.list.find(item => item.id === id);
            if (item) {
              this.handleView(item, 'update');
            } else {
              console.error(`Item with ID ${id} not found in the list.`);
            }
            return;
          }
          if (match && match[1]) {
            if (parseInt(match[1]) === 1) {
              this.listQuery.is_active = 1;
              this.listQuery.is_confirmed = 1;
            } else if (parseInt(match[1]) === 0) {
              this.listQuery.is_active = 0;
              this.listQuery.is_confirmed = 1;
            } else if (parseInt(match[1]) === 2) {
              this.listQuery.is_active = 1;
              this.listQuery.is_confirmed = 0;
            }
          } else {
            this.listQuery.is_active = this.$route.query.status || null;
          }*/
    },
    setRules() {
      return {
        // number: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        title: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        //coordinatorId: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        //coordinatorPhone: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // position: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // rate: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // rateFrequency: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // rateUnit: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // schedule1: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // city: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // coordinatorId: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // gender: [{type: 'array', required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // //quantity: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // livingExists: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // age: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // address: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // coordinatorPhone: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // workShift: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        // workShiftType: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        //isArrival: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        //description: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
      };
    },
    async getList() {
      this.listLoading = true;
      //this.parseStatusFromUrl();
      const data = await fetchList(this.listQuery);
      if (data.redirect_to) {
        // window.location.href = data.redirect_to;
      }
      this.list = data.vacancies.items.map(vacancy => {
        if (vacancy.vacancyCandidates && Array.isArray(vacancy.vacancyCandidates)) {
          // Add description_old for each vacancyCandidate
          vacancy.vacancyCandidates.forEach(candidate => {
            candidate.description_old = candidate.description;
          });
        }
        return vacancy;
      });
      await this.addDelay(100);
      console.log('list');
      console.log(this.list);
      this.total = data.vacancies.total;
      this.userRole = data.userRole;

      this.managers = data.managers;
      this.main_coordinators = data.mainCoordinators;
      this.coordinators = data.coordinators;

      this.user = data.user;

      if (this.userRole === 'manager') {
        this.temp.managerId = this.user.id;
      }

      if (this.userRole === 'coordinator_main') {
        this.temp.mainCoordinatorId = this.user.id;
      }

      if (this.userRole === 'coordinator') {
        this.temp.coordinatorId = this.user.id;
        this.temp.coordinatorPhone = this.user.phone;
      }

      this.listLoading = false;

      const {path, params} = this.$route;
      // Check if the URL contains '/edit/'
      if (path.includes('/edit/')) {
        // Extract the ID from the URL
        const id = path.split('/edit/')[1];
        this.isEditPage = true;
        this.vacancyId = id;
        console.log(`Edit mode for vacancy ID: ${this.vacancyId}`);

        // Find the vacancy from the list by vacancyId
        const foundVacancy = this.list.find(vacancy => vacancy.id === Number(this.vacancyId));

        if (foundVacancy) {
          console.log('Found Vacancy:', foundVacancy);

          // Assign found vacancy details to a reactive object
          this.temp = reactive(JSON.parse(JSON.stringify(foundVacancy)));

          // Ensure reactivity by creating a new reactive candidates array
          this.temp.candidates = foundVacancy.vacancyCandidates.map(candidate => ({
            ...candidate,
            nation: JSON.parse(candidate.nation)
          }));

        } else {
          console.warn(`Vacancy with ID ${this.vacancyId} not found in the list.`);
        }
      } else if (path.includes('/vacancies/create')) {
        this.isEditPage = false;
        if (params.id) {
          const vacancyId = params.id;
          console.log('vacancyId', vacancyId);
          const foundVacancy = this.list.find(vacancy => vacancy.id === Number(vacancyId));

          if (foundVacancy) {
            console.log('Found Vacancy:', foundVacancy);

            this.temp = reactive(JSON.parse(JSON.stringify(foundVacancy)));

            // this.temp.candidates = foundVacancy.vacancyCandidates.map(candidate => ({
            //   ...candidate,
            //   nation: JSON.parse(candidate.nation)
            // }));

            this.temp.candidates = [];

          } else {
            console.warn(`Vacancy with ID ${this.vacancyId} not found in the list.`);
          }

        }
      } else {
        this.isEditPage = false;
        console.log('Create mode');
      }
    },
    handleFilter() {
      const searchQuery = this.listQuery.search?.trim(); // Ensure search is trimmed and exists

      if (!searchQuery) {  // If searchQuery is null, undefined, or empty, reset the filter
        localStorage.removeItem('searchQuery');
        this.listQuery.search = '';
        this.listQuery.page = 1;
        this.getList();  // Return full list
      } else if (searchQuery.length === 1) {
        // Do nothing if length is 1
        return;
      } else if (searchQuery.length > 1) {  // If length > 1, search and save
        localStorage.setItem('searchQuery', searchQuery);
        this.listQuery.page = 1;
        this.getList();
      }
    },
    handleModifyStatus(row, status) {
      this.$message({
        message: 'Successful operation',
        type: 'success',
      });
      row.status = status;
    },
    sortChange(data) {
      const {prop, order} = data;
      this.sortBy(prop, order);
    },
    sortBy(prop, order) {
      if (order === 'ascending') {
        this.listQuery.sort = '+' + prop;
      } else {
        this.listQuery.sort = '-' + prop;
      }
      this.handleFilter();
    },
    resetTemp() {
      this.temp = {
        managerId: null,
        mainCoordinatorId: null,
        coordinatorId: null,
        candidatesToDelete: [],
        candidatesToHide: [],
        title: '',
        isActive: true,
        gender: [],
        images: [],
        coordinatorPhone: '',
        candidates: [
          {
            position: '',
            rate: '',
            rateFrequency: 1,
            quantity1: '',
            quantity2: '',
            quantity3: '',
            age: '',
            nation: [],
            city: '',
            address: '',
            workShift: '',
            workShiftType: '',
            schedule1: '',
            schedule2: '',
            schedule3: '',
            livingExists: '',
            livingType: '',
            livingPrice: '',
            livingPlaces1: '',
            livingPlaces2: '',
            livingPlaces3: '',
            isArrival: '',
            arrivalAddress: '',
            arrivalPrice: '',
          }
        ]
      };

      if (this.userRole === 'manager') {
        this.temp.managerId = this.user.id;
      }

      if (this.userRole === 'coordinator_main') {
        this.temp.mainCoordinatorId = this.user.id;
      }

      if (this.userRole === 'coordinator') {
        this.temp.coordinatorId = this.user.id;
        this.temp.coordinatorPhone = this.user.phone;
      }
    },
    handleCreate() {
      this.resetTemp();
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      // this.$nextTick(() => {
      //   this.$refs['dataForm'].clearValidate();
      // });
    },
    formatErrors(errors) {
      let formattedErrors = '';
      for (const key in errors) {
        if (errors.hasOwnProperty(key)) {
          formattedErrors += `${errors[key].join(', ')}\n`;
        }
      }
      return formattedErrors;
    },
    formatServerError(response) {
      let formattedError = `Статус: ${response.status} ${response.statusText}\n`;
      if (response.data && response.data.message) {
        formattedError += `Сообщение: ${response.data.message}\n`;
      }
      if (response.data && response.data.errors) {
        formattedError += this.formatErrors(response.data.errors);
      }
      return formattedError;
    },
    createData() {
      // this.$refs['dataForm'].validate((valid) => {
      //   if (valid) {
      createVacancy(this.temp)
          .then(() => {
            this.list.unshift(this.temp);
            this.dialogFormVisible = false;
            window.location.href = '/vacancies/status1';
            // this.$notify({
            //   title: 'Успешно',
            //   message: 'Вакансия создана',
            //   type: 'success',
            //   duration: 2000,
            // });
            // window.location.href = '/vacancies/status1';
          })
          .catch((error) => {
            let errorMessage = 'Произошла ошибка';
            if (error.response) {
              if (error.response.status === 422) {
                errorMessage = 'Ошибка валидации: ' + this.formatErrors(error.response.data.errors);
              } else if (error.response.status === 500) {
                errorMessage = 'Внутренняя ошибка сервера: ' + this.formatServerError(error.response);
              } else {
                errorMessage = `Ошибка: ${this.formatServerError(error.response)}`;
              }
            } else {
              // window.location.href = '/vacancies/status1';
              //errorMessage = 'Ошибка сети или сервер недоступен';
            }
            //alert(errorMessage);
          });
      // }
      // });
    },
    handleRowRightClick(row, column, event) {
      if (this.userRole !== 'recruiter_su' && this.userRole !== 'recruiter_zl') {
        event.preventDefault();
        this.handleView(row, 'edit');
      }
    },
    handleView(row, mode) {
      console.log(row);

      // Deep clone the row object
      this.temp = JSON.parse(JSON.stringify(row));

      // Ensure reactivity by setting temp.candidates to a reactive array
      this.$set(this.temp, 'candidates', this.temp.vacancyCandidates.map(candidate => {
        // Parse nation field of each candidate
        let parsedCandidate = {
          ...candidate,
          nation: JSON.parse(candidate.nation)
        };
        return parsedCandidate;
      }));

      // Set dialog properties
      this.dialogStatus = mode;
      this.dialogFormVisible = true;

      // Clear validation
      // this.$nextTick(() => {
      //   this.$refs['dataForm'].clearValidate();
      // });
    },
    updateData() {
      // this.$refs['dataForm'].validate((valid) => {
      // if (valid) {
      this.temp.candidatesToDelete = this.candidatesToDelete;
      this.temp.candidatesToHide = this.candidatesToHide;
      const tempData = Object.assign({}, this.temp);
      updateVacancy(tempData).then(() => {
        for (const v of this.list) {
          if (v.id === this.temp.id) {
            const index = this.list.indexOf(v);
            this.list.splice(index, 1, this.temp);
            break;
          }
        }
        window.location.href = '/vacancies/status1';
      });
      //  }
      //});
    },
    handleDelete(row) {
      deleteVacancy(row).then(() => {
        this.$notify({
          title: 'Успешно',
          message: 'Удалено',
          type: 'success',
          duration: 2000,
        });
        const index = this.list.indexOf(row);
        this.list.splice(index, 1);
      });
    },
    handleImage(e) {
      const files = e.target.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => {
          this.temp.images.push(e.target.result);
        };
      }
    },
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    deleteImage(index) {
      this.temp.images.splice(index, 1);
    },
    openImageInNewTab(image) {
      const url = image.startsWith('http') ? image : `${window.location.origin}/${image}`;
      window.open(url, '_blank');
    },
    handleCopyField(field, row, living = null) {
      let textToCopy = '';
      switch (field.name) {
        case 'gender':
          textToCopy = '' + row.gender.join(', ');
          break;
        case 'schedule1':
          textToCopy = '' + row.schedule1;
          if (row.schedule2 && row.schedule2 !== 'null') {
            textToCopy += ', ' + row.schedule2;
          }
          if (row.schedule3 && row.schedule3 !== 'null') {
            textToCopy += ', ' + row.schedule3;
          }
          break;
        case 'coordinatorId':
          textToCopy = '' + (row.coordinator ? row.coordinator.name : '');
          break;
        case 'coordinatorPhone':
          textToCopy = '' + (row.coordinator ? row.coordinator.phone : '');
          break;
        case 'quantity1':
          textToCopy = '' + row.quantity1;
          break;
        case 'quantity2':
          textToCopy = '' + row.quantity2;
          break;
        case 'quantity3':
          textToCopy = '' + row.quantity3;
          break;
        case 'living':
          textToCopy = '' + living
          break;
        case 'livingExists':
          textToCopy = '' + (row.livingExists === 0 ? 'No' : 'Yes');
          break;
        default:
          textToCopy = row[field.name];
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
              console.log('Text copied to clipboard: ', textToCopy);
            })
            .catch(err => {
              console.error('Failed to copy text: ', err);
            });
      } else {
        // Fallback method
        const textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          const successful = document.execCommand('copy');
          if (successful) {
            console.log('Text copied to clipboard: ', textToCopy);
          } else {
            console.error('Failed to copy text');
          }
        } catch (err) {
          console.error('Failed to copy text: ', err);
        }
        document.body.removeChild(textArea);
      }
    },
    handleCopyText(row, vacancy) {
      let scheduleText = row.schedule1;
      if (row.schedule2 && row.schedule2 !== 'null') {
        scheduleText += ' ' + row.schedule2;
      }
      if (row.schedule3 && row.schedule3 !== 'null') {
        scheduleText += ' ' + row.schedule3;
      }

      const textToCopy =
          'Название: ' + vacancy + '\n\n' +
          'Должность: ' + row.position + '\n\n' +
          'Cтавка: ' + row.rate + '\n\n' +
          'Возраст: ' + row.age + '\n\n' +
          'График: ' + scheduleText + '\n\n' +
          'Описание: ' + row.description;

      const textArea = document.createElement('textarea');
      textArea.value = textToCopy;
      document.body.appendChild(textArea);
      //textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          console.log('Text copied to clipboard');
        } else {
          console.error('Failed to copy text');
        }
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }

      document.body.removeChild(textArea);
    },
    handleCopy(data) {
      this.resetTemp();
      this.temp = data
      this.temp.id = null;
      this.temp.images = [];
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    toggleRowExpansion(row) {
      this.$refs.elTable.toggleRowExpansion(row);
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j]);
        } else {
          return v[j];
        }
      }));
    },
  },
  setup() {
    const wordConfirmed = ref("Finished");
    const wordInProgress = ref("In Progress");
    const wordPending = ref("Pending");

    const computeClass = (classValue: string) => {
      return {
        confirmed: wordConfirmed.value === classValue,
        inProgress: wordInProgress.value === classValue,
        pending: wordPending.value === classValue,
      };
    };

    return {
      computeClass,
    };
  },
  async mounted() {
    try {
      this.getList();
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  },
});
</script>

<style lang="scss" scoped>
.default-table-area {
  .table-responsive {
    .table {
      tbody {
        tr {
          td {
            ul {
              li {
                &.ms-m-15 {
                  &:first-child {
                    margin-left: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.form-select-multiple {
  height: auto; /* Allow the dropdown to expand */
  min-height: 10px; /* Set a minimum height */
}


</style>

<style>
/* Add this to your global styles or component styles */
.el-select__wrapper {
  min-height: 50px !important; /* Set minimum height */
  height: 50px !important; /* Set fixed height */
}

.el-select__wrapper .el-input__wrapper {
  height: 100% !important; /* Ensure input wrapper takes full height */
}

.el-select__wrapper .el-select__tags {
  height: 100%; /* Ensure tags container takes full height */
  overflow-y: auto; /* Add scroll if tags overflow */
}

.el-select__wrapper .el-tag {
  margin: 4px 4px 4px 0; /* Adjust tag margins */
}

.el-select__wrapper .el-tag__close {
  top: 50%; /* Center the close button */
  transform: translateY(-50%);
}

.el-select__selection.is-near {
  display: none;
}


/* Container for the row of toggles */
.toggle-row {
  margin-bottom: 40px;
  margin-top: 30px;
  display: flex; /* Use Flexbox */
  justify-content: space-between; /* Space out the toggles evenly */
  align-items: center; /* Vertically center the toggles */
  width: 100%; /* Take up full width */
  padding: 0 1rem; /* Add some padding on the sides */
}

/* Container for each toggle */
.toggle-container {
  display: flex;
  align-items: center;
  flex: 1; /* Allow each toggle to grow and take equal space */
  margin-right: 1rem; /* Spacing between toggles */
}

/* Remove margin from the last toggle */
.toggle-container:last-child {
  margin-right: 0;
}

/* Toggle label */
.toggle-label {
  font-weight: 500;
  margin-right: 1rem; /* Spacing between label and toggle */
}

/* Toggle switch container */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px; /* Width of the toggle */
  height: 25px; /* Height of the toggle */
}

/* Hide the default checkbox */
.toggle-input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* Toggle slider (the round part) */
.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc; /* Default background color */
  border-radius: 25px; /* Rounded corners */
  transition: 0.4s; /* Smooth transition */
}

/* Toggle slider circle */
.toggle-slider::before {
  position: absolute;
  content: "";
  height: 21px; /* Size of the circle */
  width: 21px; /* Size of the circle */
  left: 2px; /* Position of the circle */
  bottom: 2px; /* Position of the circle */
  background-color: white; /* Color of the circle */
  border-radius: 50%; /* Make it round */
  transition: 0.4s; /* Smooth transition */
}

/* Change background color when toggle is checked */
.toggle-input:checked + .toggle-slider {
  background-color: #409eff; /* Active background color */
}

/* Move the circle when toggle is checked */
.toggle-input:checked + .toggle-slider::before {
  transform: translateX(25px); /* Move the circle to the right */
}
</style>
